import { FieldPath, FieldValues, UseFormRegisterReturn } from "react-hook-form";
import { MessageDescriptor } from "react-intl";
import { FormGroup, Input, InputProps, Label } from "reactstrap";
import { Message } from "shared/components/Message";

type Props<TFieldValues extends FieldValues = FieldValues, TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>> = {
    label: MessageDescriptor;
    isInline?: boolean;
    innerRef: UseFormRegisterReturn<TFieldName>["ref"];
} & Omit<UseFormRegisterReturn<TFieldName>, "ref"> & Pick<InputProps, "value">;

export function Radio<TFieldValues extends FieldValues = FieldValues, TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>>({
    label,
    isInline,
    innerRef,
    ...rest
}: Props<TFieldValues, TFieldName>) {
    return <FormGroup check={true} inline={isInline}>
        <Label check={true}>
            <Input type="radio" innerRef={innerRef} {...rest} />
            <Message message={label} />
        </Label>
    </FormGroup>;
}
